import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unassign-vitotrol-remote-controller-confirm-modal',
  templateUrl: './unassign-vitotrol-remote-controller-confirm-modal.component.html',
  styleUrls: ['./unassign-vitotrol-remote-controller-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignVitotrolRemoteControllerConfirmModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<UnassignVitotrolRemoteControllerConfirmModalComponent>
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('720px');
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
    });
  }
}
